import { Component, inject, signal } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { HomePage, Language } from '../../pages/home/home.page';
import { MyOrdersPage } from '../../pages/my-orders/my-orders.page';
import { AccountPage } from '../../pages/account/account.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import { TosPage } from '../../pages/tos/tos.page';
import { ImpressumPage } from '../../pages/impressum/impressum.page';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { BarrierefreiheitPage } from 'src/app/pages/accessibility-statement/accessibility-statement.page';
import { AllergensInfoModalComponent } from '../allergens-info-modal/allergens-info-modal.component';

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['./menu-modal.component.scss'],
	standalone: false,
})
export class MenuModalComponent extends RepositoryDirective {
	private router = inject(Router);
	private modalController = inject(ModalController);
	private snackbarCtrl = inject(MatSnackBar);
	public translate = inject(TranslateService);
	public modalCtrl = inject(ModalController);

	environment = environment;
	Language = Language;
	langs = [
		{
			lang: Language.English,
			flag: 'gb',
		},
		{
			lang: Language.Norway,
			flag: 'no',
		},
	];
	currentLang = signal(this.translate.currentLang);

	constructor(public repository: RepositoryService) {
		super();
	}

	// async signIn() {
	// 	await this.modalController.dismiss();
	// 	await SignInPage.navigate(this.router);
	// }

	// async signUp() {
	// 	await this.modalController.dismiss();
	// 	SignUpPage.navigate(this.router);
	// }

	async mySpace() {
		await this.modalController.dismiss();
		await AccountPage.navigate(this.router);
	}

	async myOrders() {
		await this.modalController.dismiss();
		MyOrdersPage.navigate(this.router);
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.modalController.dismiss();
	}

	async home() {
		await this.modalController.dismiss();
		await HomePage.navigate(this.router);
	}

	async privacy() {
		await this.modalController.dismiss();
		await PrivacyPage.navigate(this.router);
	}

	async tos() {
		await this.modalController.dismiss();
		await TosPage.navigate(this.router);
	}

	async impressum() {
		await this.modalController.dismiss();
		ImpressumPage.navigate(this.router);
	}

	async allergens() {
		await this.modalController.dismiss();
		AllergensInfoModalComponent.show(this.modalCtrl);
	}

	dismiss() {
		this.modalController.dismiss();
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
		this.currentLang.set(language);
	}
}
